import React, { useState, useEffect } from 'react';
import realtimeClient from '@shared/services/realtime/websocket-client';
import i18n from "i18n";

function RealtimeAlert() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    // Check initial connection status
    const status = realtimeClient.getConnectionStatus();
    setIsConnected(status.isConnected);

    // Listen for connection status changes
    const handleStatusChange = (connected) => {
      setIsConnected(connected);
      if (!connected && !isDismissed) {
        setIsVisible(true);
      } else if (connected) {
        setIsVisible(false);
      }
    };

    realtimeClient.onConnectionStatusChange(handleStatusChange);

    // Check connection status periodically
    const checkInterval = setInterval(() => {
      const currentStatus = realtimeClient.getConnectionStatus();
      if (!currentStatus.isConnected && !isDismissed) {
        setIsVisible(true);
      }
    }, 5000);

    return () => {
      realtimeClient.off('connectionStatusChange', handleStatusChange);
      clearInterval(checkInterval);
    };
  }, [isDismissed]);

  const handleDismiss = () => {
    setIsDismissed(true);
    setIsVisible(false);
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  if (!isVisible || isDismissed) {
    return null;
  }

  return (
    <div className="realtime-alert fixed bottom-0 left-0 right-0 z-50 bg-yellow-50 border-t border-yellow-200 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <svg
              className="w-5 h-5 text-yellow-600 mr-2"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clipRule="evenodd"
              />
            </svg>
            <p className="text-sm text-yellow-800">
              <span className="font-semibold">{i18n.t('alerts.realtime_unavailable')}</span>
              {' '}
              {i18n.t('alerts.data_outdated')}
            </p>
          </div>
          <div className="flex items-center space-x-2 ml-4">
            <button
              onClick={handleRefresh}
              className="text-sm font-medium text-yellow-800 hover:text-yellow-900 underline"
            >
              {i18n.t('common.refresh')}
            </button>
            <button
              onClick={handleDismiss}
              className="text-yellow-600 hover:text-yellow-800"
              aria-label={i18n.t('common.dismiss')}
            >
              <svg
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RealtimeAlert;

